import Head from 'next/head';
import Image from 'next/image';

import ManageAddress from '../../components/ManageAddress';
import { pageTitle } from '../../components/shared/basic/customHead';
import HeadingV2 from '../../components/shared/HeadingV2';
import { ArrowFaq } from '../../../assets';

const ManageAddressesPage = () => {
  return (
    <div>
      <Head>
        <title>{pageTitle('Manage Addresses')}</title>
      </Head>
      <div className='relative overflow-hidden pb-20'>
        <div className='px-10 lg:px-24 pt-14 flex flex-col gap-y-10'>
          <span>
            <HeadingV2 heading='Addresses' />
          </span>
          <span className='md:w-2/3'>
            <ManageAddress />
          </span>
        </div>
        <span className='flex justify-end w-full absolute top-20 xl:top-[2%] translate-x-12'>
          <span className='w-36 md:w-44 lg:w-60 '>
            <Image src={ArrowFaq} alt='ArrowFaq' />
          </span>
        </span>
      </div>
    </div>
  );
};

export default ManageAddressesPage;
